<div>
  <ng-container *ngIf="isMobile">
    <div (click)="goToLogin()" class="arrow-left">
      <img src="assets/image/arrow-left.svg" />
    </div>
  </ng-container>

  <ng-container *ngIf="!isMobile">
    <div class="desc">
      <div class="mt-5 text-center">
        <img src="assets/image/merchants/{{ merchant }}/logo-login-blue.svg" />
      </div>
      <div class="text-login mt-3 text-center">
        <h3>Boas-vindas!</h3>
        <p>
          Entre na sua conta ou crie uma gratuitamente para começar a enviar e
          receber dinheiro para outros países.
        </p>
        <div class="mt-5 mb-4 text-center">
          <img src="assets/image/circles.svg" alt="Logo Oz Câmbio" />
        </div>
      </div>
    </div>
  </ng-container>

  <div class="container-login">
    <div class="text-login mt-5">
      <h4>Login</h4>
      <p class="mt-3">Digite seu e-mail e senha para acessar a plataforma.</p>
    </div>
    <form
      [formGroup]="loginForm"
      (ngSubmit)="loginForm.valid ? signIn() : null"
      class="mt-3"
    >
      <div>
        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="username" type="text" />
          <mat-error
            class="mb-1"
            *ngIf="
              loginFormControl.username.touched &&
              loginFormControl.username.errors?.required
            "
          >
            E-mail obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="mb-3">
          <mat-label>Senha</mat-label>
          <input
            [type]="hide ? 'password' : 'text'"
            matInput
            formControlName="password"
          />

          <button
            type="button"
            class="eye-color"
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <img
              [src]="
                hide
                  ? 'assets/image/eye-icon-open.svg'
                  : 'assets/image/eye-icon-close.svg'
              "
            />
          </button>
          <mat-error
            class="mb-1"
            *ngIf="
              loginFormControl.password.touched &&
              loginFormControl.password.errors?.minlength
            "
          >
            Digite uma senha de no mínimo oito caracteres
          </mat-error>
          <mat-error
            class="mb-1"
            *ngIf="
              loginFormControl.password.touched &&
              loginFormControl.password.errors?.required
            "
          >
            Senha obrigatória
          </mat-error>
        </mat-form-field>
        <input [style.display]="'none'" type="submit" />
      </div>
      <div>
        <button
          [ngClass]="{
            'btn-gray-disabled': loginForm.invalid,
            'btn-dark-blue': !loginForm.invalid
          }"
          [disabled]="loginForm.invalid"
          class="btn btn-block mb-3"
          type="button"
          (click)="signIn()"
        >
          Entrar
          <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
        </button>
      </div>
    </form>
    <div class="forgot-pass text-center">
      <a (click)="goToForgotPass()">Esqueceu a senha</a>
      <p class="mt-4">
        Não tem conta?
        <!--  <a routerLink="{{ '/' + tenant + '/register/user' }}"
          >Crie sua conta.</a
        > -->
        <a routerLink="{{ '/' + tenant + '/person-type' }}">Crie sua conta.</a>
      </p>
    </div>

    <ng-container *ngIf="isMobile">
      <div class="text-center mt-5 lg-bottom">
        <div class="text-white" *ngIf="tenant !== tenantService.XP_NAME">
          <span>Fornecido por: </span>
        </div>
        <br />
        <img
          class="logo-oz"
          src="../../../../assets/image/merchants/{{
            merchant
          }}/oz-white-logo.svg"
          alt="logo"
        />
      </div>
    </ng-container>
  </div>
</div>
